module.exports = __webpack_public_path__ + "src/assets/sounds/wax_sound.mp3";